export const getFormattedDateForCard = (dateTime: Date): string => {
  const lang = 'en-US';

  const optionsWeekday: Intl.DateTimeFormatOptions = {
    weekday: 'long',
  };
  const optionsDate: Intl.DateTimeFormatOptions = {
    day: '2-digit',
  };

  const optionsMonth: Intl.DateTimeFormatOptions = {
    month: 'short',
  };

  const weekday = dateTime.toLocaleDateString(lang, optionsWeekday);
  const dateNum = dateTime.toLocaleDateString(lang, optionsDate);
  const month = dateTime.toLocaleDateString(lang, optionsMonth);
  return `${weekday}, ${month} ${dateNum}`;
};

export const getFormattedMonthForCard = (dateTime: Date): string => {
  const lang = 'en-US';
  const optionsMonth: Intl.DateTimeFormatOptions = {
    month: 'short',
  };
  return dateTime.toLocaleDateString(lang, optionsMonth);
};

export const getFormattedTimeForCard = (dateTime: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  const timeString = dateTime.toLocaleTimeString(undefined, options);
  return timeString.replace(/\s([ap]m)$/, '$1').toLowerCase();
};
